import { xMedian } from './xMedian';
import { xRolling } from './xRolling';
/**
 * This function calculates a rolling average
 * @param array - array
 * @param options - options
 */
export function xRollingMedian(array, options = {}) {
    return xRolling(array, xMedian, options);
}
//# sourceMappingURL=xRollingMedian.js.map